
const CouponUpdatedModal = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="coupon-modal-overlay">
      <div className="coupon-modal-box">

        <h3>Coupon Updated</h3>

        <p>{message}</p>

        <button className="btn btn-dark mt-3" onClick={onClose}>
          OK
        </button>

      </div>
    </div>
  );
};

export default CouponUpdatedModal;